export default __webpack_public_path__ + "static/simple-doughnut-01d14a0087b5ceef904a42856c013390.png";